import { isPlatformBrowser } from '@angular/common'
import { Component, OnInit, inject, PLATFORM_ID, DestroyRef, ChangeDetectionStrategy, signal } from '@angular/core'
import { ConfigService } from '@shared/services/config.service'
import { ApiService } from '@shared/services/api.service'
import { ServiceNotification } from '@shared/interfaces'
import { RouterOutlet } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { SuccessMessageComponent } from '@shared/components/success-message/success-message.component'
import { ErrorMessageComponent } from '@shared/components/error-message/error-message.component'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, TranslatePipe, SuccessMessageComponent, ErrorMessageComponent],
})
export class LayoutComponent implements OnInit {
  private platformId = inject(PLATFORM_ID)
  private destroyRef = inject(DestroyRef)
  config = inject(ConfigService)
  api = inject(ApiService)

  serviceNotification = signal<ServiceNotification | null>(null)

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return
    }

    const serviceNotification$ = this.api.getServiceNotification?.()
    if (!serviceNotification$) {
      return
    }
    serviceNotification$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      this.serviceNotification.set(response)
    })
  }
}
